import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

interface SectionProps {
  readonly title: MessageKey;
  readonly className?: string;
  readonly children: ReactNode;
}

const Section = ({
  title,
  className,
  children,
  ...props
}: SectionProps): JSX.Element => {
  const t = useTranslations();

  return (
    <section className={cx('mb-16 mt-8', className)} {...props}>
      <TypographyV3 Element="h3" variant="h3" className="mb-8">
        {t(title)}
      </TypographyV3>

      {children}
    </section>
  );
};

export default Section;
